import { useState } from 'react'

type Option = {
  value: string
  label: string
}

export const useMultiSelectWithSearch = () => {
  const [searchQuery, setSearchQuery] = useState('')
  const [selectedOptions, setSelectedOptions] = useState<Option[]>([])

  const createOptionsWithPreservedSelections = (
    options: Option[],
    selectedValues: string[] = [],
  ): Option[] => {
    if (selectedValues.length === 0) {
      return options
    }

    const existingValues = options.map(option => option.value)
    const missingValues = selectedValues.filter(value => !existingValues.includes(value))

    if (missingValues.length > 0) {
      const missingOptions = selectedOptions.filter(option => missingValues.includes(option.value))
      return [...options, ...missingOptions]
    }

    return options
  }
  const saveSelectedOptions = (options: Option[], selectedValues: string[]) => {
    const selected = options.filter(option => selectedValues.includes(option.value))
    setSelectedOptions(prev => {
      return [...prev, ...selected]
    })
  }

  return {
    searchQuery,
    setSearchQuery,
    createOptionsWithPreservedSelections,
    saveSelectedOptions,
  }
}
